var key = "bfywMjvMBW4qSwrqmtFP0xxsiZarzH0dvogTKWNR";

module.exports = {
  key,
};
